import { http as defaultHttp } from "../utils/http";
import { AxiosInstance } from "axios";

// abstract class
export class HttpService {
  protected http: AxiosInstance;
  constructor({http = defaultHttp} = {}) {
    this.http = http;
  }
}